import { render, staticRenderFns } from "./StockArchivedTransaction.vue?vue&type=template&id=04919c41&scoped=true&"
import script from "./StockArchivedTransaction.vue?vue&type=script&lang=ts&"
export * from "./StockArchivedTransaction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04919c41",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
